import type { SVGProps } from "react";

export default function SolarTestTubeLinear(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.2em"
            height="1.2em"
            viewBox="0 0 24 24"
            {...props}
        >
            <g fill="none" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" d="M13.5 2h-3M8 2v4m8-4v4" />
                <path d="M6 16c0 3.314 2.686 6 6 6s6-2.686 6-6V6H6v10Z" />
                <path strokeLinecap="round" d="M6 11h12" />
            </g>
        </svg>
    );
}
